import TemplateView from '../../../../TemplateView'
import EntityListItem from './EntityListItem'
import LoadingContainer from '../../../../util/LoadingContainer'
import ComponentsList from '../../../../util/ComponentsList'
import {HierarchyLevels} from 'constants'
import messageResource from '../../../../messageResource'

export default class EntitiesList extends TemplateView {
    constructor({
        hierarchyLevel = '',
        showProjectsCount = false,
        showTasksCount = false,
        workAssignmentsVisible = true,
        managementAssignmentsEditable = true,
        entitiesClickable = false,
        revokeMenu = null,
        revokeMenuTextsMaps = {},
        onAssignmentChange = (entityId, assigned) => {},
        onEntityClick = entityId => {},
        checkIfViewerCanManage = itemId => false,
    }) {
        super()

        this.params = {
            hierarchyLevel,
            showProjectsCount,
            showTasksCount,
            workAssignmentsVisible,
            managementAssignmentsEditable,
            entitiesClickable,
            revokeMenu,
            revokeMenuTextsMaps,
            checkIfViewerCanManage,
        }

        this.callbacks = {
            onAssignmentChange,
            onEntityClick
        }

        this.state = {
            entities: [],
            futureAssigned: false,
            canWorkIds: {},
            canManageIds: {},
            canManageExcludeSelfIds: {},
            projectCounts: {},
            taskCounts: {},
            changingAssignments: {},
            topLevelAccess: false,
            readOnlyTooltipText: "",
        }

        this.onStateChanged(({entities}) => this.componentsList.setState({
            items: entities
        }))
    }

    templateHtml() {
        return "<div class='entitiesList'></div>"
    }

    afterRender() {
        this.componentsList = new ComponentsList({
            itemToComponent: entity => new LoadingContainer({
                containerClass: 'entityItemLoadingWrapper',
                contentComponent: new EntityListItem({
                    hierarchyLevel: this.params.hierarchyLevel,
                    showProjectsCount: this.params.showProjectsCount,
                    showTasksCount: this.params.showTasksCount,
                    clickable: this.params.entitiesClickable,
                    revokeMenu: this.params.revokeMenu,
                    revokeMenuTextsMaps: this.params.revokeMenuTextsMaps,
                    isArchived: entity.archived || (!entity.archived && !entity.open),
                    onAssignmentChanged: assigned => this.callbacks.onAssignmentChange(entity.id, assigned),
                    onClick: () => this.callbacks.onEntityClick(entity.id)
                })
            }),
            itemToState: entity => {
                const id = entity.id
                const canWork = !!this.state.canWorkIds[id]
                const canManage = !!this.state.canManageIds[id]
                const canManageExcludeSelf = this.state.canManageExcludeSelfIds[id]
                const assigned = this.params.workAssignmentsVisible && canWork || canManage
                const viewerCanManage = this.params.checkIfViewerCanManage(id)
                const disabled = !this.params.workAssignmentsVisible && this.state.futureAssigned ||
                                 !this.params.managementAssignmentsEditable && canManage ||
                                 this.params.workAssignmentsVisible && canManageExcludeSelf ||
                                 !this.params.workAssignmentsVisible && this.state.topLevelAccess ||
                                 !viewerCanManage
                let disabledCheckboxTooltipText = this.state.readOnlyTooltipText
                let hierarchyLevelName = ""
                let childHierarchyLevelName = ""
                if (this.params.hierarchyLevel === HierarchyLevels.CUSTOMER) {
                    hierarchyLevelName = messageResource.getMessage('common.customer')
                    childHierarchyLevelName = messageResource.getMessage('common.projects')
                } else if (this.params.hierarchyLevel === HierarchyLevels.PROJECT) {
                    hierarchyLevelName = messageResource.getMessage('common.project')
                    childHierarchyLevelName = messageResource.getMessage('common.tasks')
                } else if (this.params.hierarchyLevel === HierarchyLevels.TASK) {
                    hierarchyLevelName = messageResource.getMessage('common.task')
                }

                if (this.params.workAssignmentsVisible && !viewerCanManage) {
                    disabledCheckboxTooltipText = messageResource.getMessage(
                        'assigned_users_editor.work.disabled_tooltip.no_permission_to_manage',
                        [hierarchyLevelName]
                    )
                } else if (this.params.workAssignmentsVisible && disabled && !this.state.topLevelAccess) {
                    if (canManageExcludeSelf) {
                        disabledCheckboxTooltipText = messageResource.getMessage(
                            'assigned_users_editor.disabled_tooltip.user_manage_all_existing_and_future',
                            [hierarchyLevelName, childHierarchyLevelName]
                        )
                    } else if (canManage) {
                        disabledCheckboxTooltipText = messageResource.getMessage(
                            'assigned_users_editor.work.disabled_tooltip.user_manages_item',
                            [hierarchyLevelName]
                        )
                    }
                }

                let canManageSubtitleText = ''
                if (canManageExcludeSelf) {
                    canManageSubtitleText = messageResource.getMessage('userlist.ha_editor.can_manage_existing_and_future', [childHierarchyLevelName])
                } else if (canManage) {
                    canManageSubtitleText = messageResource.getMessage('userlist.ma_editor.can_manage')
                }

                return {
                    name: entity.name,
                    assigned,
                    disabled,
                    showCanManage: (canManage || canManageExcludeSelf) && this.params.workAssignmentsVisible,
                    projectsCount: this.state.projectCounts[id] || 0,
                    tasksCount: this.state.taskCounts[id] || 0,
                    loading: !!this.state.changingAssignments[id],
                    isArchived: entity.archived || (this.params.hierarchyLevel === HierarchyLevels.TASK && !entity.open),
                    disabledTooltipText: disabledCheckboxTooltipText,
                    canManageSubtitleText: canManageSubtitleText,
                }
            }
        }).init(this.$el)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/EntitiesList.js